module.exports = __webpack_public_path__ + "static/media/HRF_Logo.47393655.png";